// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__3XSFj","ul":"Sidebar_ul__1G5JF","hideLi":"Sidebar_hideLi__26B1q","li":"Sidebar_li__1vgAc","a":"Sidebar_a__3KQ1X","liActive":"Sidebar_liActive__2zUm5"};